/* Native page navigation is the fallback. Preserve applied filters when sorting. */
(() => {
  if (window.effyBrowseInitialized) return;
  window.effyBrowseInitialized = true;
  const initializeCompactControls = (section) => {
    if (section.dataset.effyCompactReady) return;
    const toolbar = section.querySelector('.effy-browse__toolbar');
    const filters = section.querySelector('.effy-browse__filters');
    const sort = section.querySelector('[data-effy-sort-form]');
    if (!toolbar || (!filters && !sort)) return;
    section.dataset.effyCompactReady = 'true';

    // Move the original controls, keeping their native forms, URLs and listeners.
    const panel = filters || document.createElement('details');
    if (!filters) {
      panel.className = 'effy-browse__filters';
      panel.append(document.createElement('summary'));
    }
    const summary = panel.querySelector('summary');
    const originalSummary = summary.textContent;
    const filterPosition = filters ? document.createComment('EFFY desktop filters') : null;
    if (filters) filters.before(filterPosition);
    const sortPosition = sort ? document.createComment('EFFY desktop sort') : null;
    const mobileSort = sort ? document.createElement('div') : null;
    if (sort) {
      sort.before(sortPosition);
      mobileSort.className = 'effy-browse__mobile-sort';
    }
    const appliedCount = section.querySelectorAll('.effy-browse__active .effy-browse__chip a, .effy-browse__active .effy-browse__chip-link').length;
    const compactLabel = filters ? (sort ? 'Filter & sort' : 'Filter') : 'Sort';
    const breakpoint = window.matchMedia('(max-width: 850px)');
    let compact;
    const updateLayout = () => {
      if (compact === breakpoint.matches) return;
      compact = breakpoint.matches;
      toolbar.classList.toggle('effy-browse__toolbar--compact', compact);
      panel.classList.toggle('effy-browse__filters--compact', compact);
      if (compact) {
        summary.textContent = compactLabel + (appliedCount ? ` (${appliedCount} applied)` : '');
        panel.open = false;
        if (sort) {
          mobileSort.append(sort);
          summary.after(mobileSort);
        }
        toolbar.append(panel);
      } else {
        if (sort) {
          sortPosition.after(sort);
          mobileSort.remove();
        }
        summary.textContent = originalSummary;
        if (filters) {
          filterPosition.after(panel);
          panel.open = true;
        } else {
          panel.remove();
        }
      }
    };
    panel.addEventListener('keydown', (event) => {
      if (compact && panel.open && event.key === 'Escape') {
        panel.open = false;
        summary.focus();
        event.stopPropagation();
      }
    });
    breakpoint.addEventListener('change', updateLayout);
    const cleanup = (event) => {
      if (event.target === section || event.target.contains(section)) {
        breakpoint.removeEventListener('change', updateLayout);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
    };
    document.addEventListener('shopify:section:unload', cleanup);
    updateLayout();
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-effy-sort-form]').forEach((form) => {
      if (form.dataset.effyReady) return;
      form.dataset.effyReady = 'true';
      form.addEventListener('submit', (event) => {
        const field = form.querySelector('[name="sort_by"]');
        if (!field) return;
        event.preventDefault();
        const destination = new URL(window.location.href);
        destination.searchParams.delete('page');
        destination.searchParams.set('sort_by', field.value);
        destination.hash = form.dataset.resultsAnchor || '';
        window.location.assign(destination.href);
      });
    });

    root.querySelectorAll('[data-effy-tag-link] a').forEach((link) => {
      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;
      const currentParameters = new URLSearchParams(window.location.search);
      for (const key of new Set(currentParameters.keys())) {
        if (key === 'sort_by' || key === 'q' || key === 'view' || key === 'preview_theme_id' || key.startsWith('filter.')) {
          if (!destination.searchParams.has(key)) {
            currentParameters.getAll(key).forEach((value) => destination.searchParams.append(key, value));
          }
        }
      }
      destination.searchParams.delete('page');
      link.href = destination.href;
    });

    root.querySelectorAll('.effy-browse').forEach(initializeCompactControls);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
